<template>
  <div :class="['agreementBox', { inApp: $root.$data.isApp }]">
    <template v-if="loadingTip">
      <van-loading size="24px" vertical>加载中...</van-loading>
    </template>
    <template v-else>
      <common-title
        :titleName="titleName"
        v-if="!$root.$data.isApp"
        :bcColor="'#FEFEFF'"
        :zIndex="1000"
      ></common-title>
      <div
        :class="[
          'agreementContent',
          { paddUi: completeSign || detailBox.isWriteInformation !== 1 },
        ]"
      >
        <!-- pdf链接 -->
        <div class="iframeFather" v-if="detailBox.type === 1">
          <iframe id="iframeUi" :src="src + '#toolbar=0'" frameborder="0"></iframe>
        </div>
        <!-- 富文本 -->
        <div v-if="detailBox.type === 2">
          <div v-html="detailBox.introduction"></div>
        </div>
      </div>
      <template v-if="signingBox.status === 1">
        <div class="agreementBottom" v-if="detailBox.type === 1">
          <template v-if="detailBox.isWriteInformation === 1">
            <div class="infoFrom">
              <van-field v-model="cardName" placeholder="请输入真实姓名" @blur="checkUserList(1)" />
              <van-field
                v-model.trim="cardId"
                placeholder="请输入身份证号"
                maxlength="18"
                @blur="checkUserList(2)"
              />
              <van-field
                v-model.trim="phoneId"
                placeholder="请输入手机号"
                maxlength="11"
                @blur="checkUserList(3)"
                @input="getphoneValue"
              />
              <div class="verificationBox">
                <van-field
                  v-model.trim="codeId"
                  style="width: 72%"
                  placeholder="请输入短信验证码"
                />
                <div
                  :class="['verify_phone_btn', { orangebtn: phoneFlag }]"
                  @click="getVerification()"
                  v-show="!isBtnFlag"
                >
                  {{ phoneCodeText }}
                </div>
                <div class="verify_phone_btn" v-show="isBtnFlag">
                  重新获取({{ codeNewCount }}<b class="minutes">s</b>)
                </div>
              </div>
             
            </div>
            <div class="pravieWarrp">
              <span>为了您的合法权益，请务必输入真实身份信息</span>
              <div class="pravieBox">
                <img
                  v-show="!pravie"
                  src="@/assets/img/personalCenter/login-check.png"
                  alt=""
                  @click="pravie = !pravie"
                />
                <img
                  v-show="pravie"
                  src="@/assets/img/personalCenter/login-checked.png"
                  alt=""
                  @click="pravie = !pravie"
                />
                我已阅读并同意<span @click="goPage('1')">认证服务协议</span>和<span
                  @click="goPage('2')"
                  >用户隐私政策</span
                >。
              </div>
            </div>

            <button
              :disabled="!bottomBtn"
              :class="bottomBtn ? 'orangebtn' : 'garynoActive'"
              @click="readingAgreePdf"
            >
              我已阅读并同意签署协议
            </button>

            <p @click="goBack">下次再说</p>
          </template>
          <div v-else>
            <span class="lawfulRight">为了您的合法权益，请务必输入真实身份信息</span>
            <button
              :disabled="!isCodeFlag"
              :class="isCodeFlag ? '' : 'noActive'"
              @click="readingAgree"
            >
              我已阅读并同意
              <b v-if="!isCodeFlag">（{{ codeCount }}S）</b>
            </button>
            <p @click="goBack">下次再说</p>
          </div>
        </div>
        <div class="agreementBottom" v-if="detailBox.type === 2">
          <div class="infoFrom" v-if="detailBox.isWriteInformation === 1">
            <van-field v-model="cardName" placeholder="请输入姓名" />
            <van-field v-model.trim="cardId" placeholder="请输入身份证号" maxlength="18" />
          </div>
          <span class="lawfulRight">为了您的合法权益，请务必输入真实身份信息</span>
          <button
            :disabled="!isCodeFlag"
            :class="isCodeFlag ? '' : 'noActive'"
            @click="readingAgree"
          >
            我已阅读并同意
            <b v-if="!isCodeFlag">（{{ codeCount }}S）</b>
          </button>
          <p @click="goBack">下次再说</p>
        </div>
      </template>
      <div class="footTime" v-if="completeSign">
        <div class="footTimeContent">
          <div
            class="agreementTime"
            v-if="detailBox.isWriteInformation === 1 && detailBox.type === 2"
          >
            <span>姓名:</span>
            <b>{{ signingBox.realName }}</b>
          </div>
          <div
            class="agreementTime"
            v-if="detailBox.isWriteInformation === 1 && detailBox.type === 2"
          >
            <span>身份证号:</span>
            <b>{{ signingBox.idNumber }}</b>
          </div>
          <div class="agreementTime">
            <span>签署时间:</span>
            <b>{{ signingBox.signingTime ? signingBox.signingTime.slice(0, 11) : `暂无` }}</b>
          </div>
          <div class="agreementTime" v-if="signingBox.deadlineTime && detailBox.isShowValid === 1">
            <span>有效期至:</span>
            <b>{{ signingBox.deadlineTime ? signingBox.deadlineTime.slice(0, 11) : `暂无` }}</b>
          </div>
        </div>
      </div>
      <div v-if="signingBox.status === 1 && detailBox.isWriteInformation === 1">
        <van-popup v-model="showPop" class="knowAgreement">
          <div>
            <h2>重要提醒</h2>
            <h3>
              感谢您选择:<br />我们非常重视您的个人信息和隐私保护，为了更好的保障您的个人权益，在您使用我们的产品前，请务必审慎填写您的真实信息及阅读《隐私政策》、《服务条款》内的所有条款，同意并接受全部条款后即可开始使用我们的产品和服务。
            </h3>
            <div @click="knowBtn">我知道了</div>
          </div>
        </van-popup>
      </div>

      <div class="agreementWait" v-if="loadingWait">
        <div class="waitCenter">
          <div>
            <img src="@/assets/img/personalCenter/loadAgree.gif" alt="" />
            <span>正在签署协议,请稍后…</span>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import CommonTitle from '@/components/header/CommonTitle.vue';
import { resAgreementInfo, resSignedAgreement } from '@/api/personal/myAgreement';
import { reqPhonesliderCode } from '@/api/login';
import { initCaptcha,triggerCaptcha } from '@/utils/tools';


export default {
  components: {
    CommonTitle,
  },
  data() {
    return {
      codeCount: 10, // 阅读倒计时
      codeNewCount: 60, // 验证码60s 倒计时
      isCodeFlag: true, // 按钮状态
      timer: null,
      completeSign: false,
      detailBox: [],
      signedList: {
        agreementId: 0,
        productId: 0,
        terminal: 0,
        userId: 0,
        userProductId: 0,
        idNumber: 0,
        realName: 0,
        smsCode: '',
        phone: '',
      },
      titleName: '协议',
      loadingTip: true,
      signingTime: null,
      deadlineTime: null,
      signingBox: {},
      lastPath: false,
      antiPoint: false, // 防连点
      cardName: '',
      cardId: '',
      showPop: true,
      src: '', // pdf文件地址
      phoneCodeText: '获取验证码',
      codeId: '', // 验证码
      phoneId: '', // 手机号
      oldTimer: null,
      pravie: false, // 是否勾选隐私政策
      isBtnFlag: false,
      bottomBtn: false, // 底部协议按钮
      phoneFlag: false,
      pattern: /^1(3|4|5|6|7|8|9)\d{9}$/, // 正则验证手机号
      loadingWait: false, // 签署协议时的loading状态
    };
  },

  computed: {},
  mounted() {
    initCaptcha('16dqi6jq',this.nvcCallback);
    this.getAgressmentMation();
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      //  这里的vm指的就是vue实例，可以用来当做this使用
      if (from.path === '/personalCenter/myAgreement') {
        // eslint-disable-next-line no-param-reassign
        vm.lastPath = true;
      }
    });
  },
  methods: {
    nvcCallback(data){
      this.getNewVerification(data)
    },
    readingCount() {
      const TIME_COUNT = 10;
      this.codeCount = TIME_COUNT;
      this.isCodeFlag = false;
      this.timer = setInterval(() => {
        if (this.codeCount > 0 && this.codeCount <= TIME_COUNT) {
          // eslint-disable-next-line no-plusplus
          this.codeCount--;
        } else {
          this.isCodeFlag = true;
          clearInterval(this.timer);
          this.timer = null;
        }
      }, 1000);
    },
    async readingAgree() {
      if (this.detailBox.isWriteInformation === 1) {
        if (this.cardName === undefined || this.cardName === '') {
          this.$toast('请输入姓名');
        } else if (this.cardId === undefined || this.cardId === '') {
          this.$toast('请输入身份证号');
        } else if (this.cardId.length < 18) {
          this.$toast('请输入正确的身份证号');
        } else {
          this.signedList.idNumber = this.cardId;
          this.signedList.realName = this.cardName;
          this.agreementSign();
        }
      } else {
        this.agreementSign();
      }
    },
    async agreementSign() {
      if (this.antiPoint) return;
      this.antiPoint = true;
      this.loadingWait = true;
      const res = await resSignedAgreement(this.signedList);
      if (res?.code === 0) {
        //  签署成功
        this.loadingWait = false;
        this.$toast('协议签署成功');

        setTimeout(() => {
          if (this.$root.$data.isApp) {
            if (this.lastPath) {
              this.$router.go(-1);
            } else {
              this.$sendToApp('closePage');
            }
          } else {
            // 返回上一级
            this.$router.go(-1);
          }
          this.lastPath = false;
        }, 1000);
      } else if (res?.code === 7000) {
        this.loadingWait = false;
        this.$toast(res.msg);
      } else {
        this.loadingWait = false;
        this.$toast(res.msg);
      }
      setTimeout(() => {
        this.antiPoint = false;
      }, 2000);
    },
    knowBtn() {
      this.showPop = false;
    },
    goBack() {
      // 签署方式 1随时签署 2学习前签署
      const { agreementType } = this.signingBox;
      if (this.lastPath) {
        // 返回上一级
        this.$router.go(-1);
        this.lastPath = false;
        return;
      }
      if (agreementType === 2) {
        if (this.$root.$data.isApp) {
          this.$sendToApp('closePage');
        } else {
          // 返回上一级
          this.$router.push({
            path: '/personalCenter/mycourseList',
          });
        }
        return;
      }
      if (this.$root.$data.isApp) {
        this.$sendToApp('closePage');
      } else {
        // 返回上一级
        this.$router.go(-1);
      }
    },

    async getAgressmentMation() {
      const openId = this?.$route?.query.userProductId;
      const res = await resAgreementInfo(openId);
      if (res.code === 0) {
        this.detailBox = res.data?.agreementRespVO;
        this.signingBox = res.data?.userAgreementRespVO || {};
        this.completeSign = res.data.signFlag;
        this.titleName = res.data.signFlag ? '我的协议' : '协议';
        this.loadingTip = false;
        if (this.detailBox.type === 1) {
          if (this.completeSign) {
            if (!res.data?.userAgreementRespVO?.address) {
              this.$toast('pdf地址无效');
              return;
            }
            this.src = `https://www.iqihang.com/zt/pdfjs/build/generic/web/viewer.html?file=${res.data?.userAgreementRespVO?.address}`;
            // this.src = res.data?.userAgreementRespVO?.address;
            console.log(this.src, 'this.src');
          } else {
            this.src = `https://www.iqihang.com/zt/pdfjs/build/generic/web/viewer.html?file=${res.data?.agreementRespVO?.pdfAddress}`;
          }
        }
        this.signedList = {
          agreementId: res.data.userAgreementRespVO.agreementId,
          productId: res.data.userAgreementRespVO.productId,
          terminal: this.$global.userTerminal,
          userId: res.data.userAgreementRespVO.userId,
          userProductId: res.data.userAgreementRespVO.userProductId,
        };
        if (
          (this.signingBox.status === 1 &&
            this.detailBox.type === 1 &&
            this.detailBox.isWriteInformation !== 1) ||
          (this.signingBox.status === 1 && this.detailBox.type === 2)
        ) {
          this.readingCount();
        }
      } else {
        this.$toast(res.msg);
      }
    },
    async readingAgreePdf() {
      if (!this.pravie) {
        this.$toast('请阅读并勾选认证服务协议与用户隐私政策');
      } else if (this.cardName === undefined || this.cardName === '') {
        this.$toast('请输入姓名');
      } else if (this.cardId === undefined || this.cardId === '') {
        this.$toast('请输入身份证号');
      } else if (this.cardId.length < 18) {
        this.$toast('请输入正确的身份证号');
      } else if (this.codeId === undefined || this.codeId === '') {
        this.$toast('请输入短信验证码');
      } else if (this.phoneId === undefined || this.phoneId === '') {
        this.$toast('请输入手机号');
      } else if (!this.pattern.test(this.phoneId)) {
        this.$toast('请输入正确格式的手机号');
      } else {
        this.signedList.idNumber = this.cardId;
        this.signedList.realName = this.cardName;
        this.signedList.smsCode = this.codeId;
        this.signedList.phone = this.phoneId;

        this.agreementSign();
      }
    },
    checkUserList(num) {
      if (num === 1) {
        if (this.cardName === undefined || this.cardName === '') {
          this.$toast('请输入姓名');
        }
      } else if (num === 2) {
        if (this.cardId === undefined || this.cardId === '') {
          this.$toast('请输入身份证号');
        } else if (this.cardId.length < 18) {
          this.$toast('请输入正确的身份证号');
        }
      } else if (num === 3) {
        if (this.phoneId === undefined || this.phoneId === '') {
          this.$toast('请输入手机号');
          this.phoneFlag = false;
        } else if (!this.pattern.test(this.phoneId)) {
          this.$toast('请输入正确格式的手机号');
          this.phoneFlag = false;
        } else {
          this.phoneFlag = true;
        }
      }
    },
    getphoneValue() {
      if (!this.pattern.test(this.phoneId)) {
        this.phoneFlag = false;
      } else {
        this.phoneFlag = true;
      }
    },

    // 获取验证码
    async getVerification() {
      if (this.cardId === undefined || this.cardId === '') {
        this.$toast('请输入身份证号');
      } else if (this.cardId.length < 18) {
        this.$toast('请输入正确的身份证号');
      } else if (this.cardName === undefined || this.cardName === '') {
        this.$toast('请输入姓名');
      } else {
        triggerCaptcha()
      }
    },

    goPage(num) {
      let url = '';
      if (Number(num) === 1) {
        url = 'https://mobile.iqihang.com/zt/privacy_app/service.html';
      } else {
        url = 'https://mobile.iqihang.com/zt/privacy_app/index.html';
      }
      if (this.$root.$data.isApp) {
        this.$sendToApp('openNewWebView', { url }, false);
      } else {
        window.open(url);
      }
    },
    // 发送验证码
    async getNewVerification(nvcVal) {
      const TIME_COUNT = 60;
      this.codeNewCount = TIME_COUNT;
      const data = {
        company: 0,
        type: 'agreementSign',
        phone: String(this.phoneId) || '',
        nvcVal,
         sceneId: '16dqi6jq'
      };
      const res = await reqPhonesliderCode(data);
      initCaptcha('16dqi6jq',this.nvcCallback);
      if (res.code === 0) {
        if (res.data.status === 0) {
          this.isBtnFlag = true;
          this.bottomBtn = true;
          this.timer = setInterval(() => {
            if (this.codeNewCount > 0 && this.codeCount <= TIME_COUNT) {
              // eslint-disable-next-line no-plusplus
              this.codeNewCount--;
            } else {
              this.isBtnFlag = false;
              clearInterval(this.timer);
              this.timer = null;
            }
          }, 1000);
        } else if (res.data.status === 1) {
          // 业务服务器请求回调控制是否需要二次验证
          if (res.data.bizCode === 800 || res.data.bizCode === 900) {
            // 无痕验证失败，直接拦截
            this.$toast('验证失败，请重新尝试');
          } else if (res.data.bizCode === 400) {
           triggerCaptcha()
          }
        }
      } else {
        this.$toast(res.msg);
      }
    },
  },
  beforeDestroy() {
    clearInterval(this.timer);
    this.timer = null;
  },
};
</script>

<style lang="scss" scoped>
.agreementBox {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  margin: 0 auto;
  padding-top: 100px;
  &.inApp {
    padding-top: 0;
    padding-bottom: 0;
  }
  .agreementContent {
    padding: 10px 30px 510px 30px;
    background: #fff;
    .iframeFather {
      // -webkit-overflow-scrolling: touch; /* 当手指从触摸屏上移开，会保持一段时间的滚动 */
      // overflow-y: scroll;
      #iframeUi {
        width: 100%;
        // min-height: 1300px;
        height: 65vh;
      }
    }
  }
  .agreementContent.paddUi {
    padding-bottom: 150px;
    .iframeFather {
      #iframeUi {
        height: 82vh;
      }
    }
  }

  .agreementBottom {
    position: fixed;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    margin: 0 auto;
    padding: 2px 0 38px 0;
    text-align: center;
    background: #fff;
    box-shadow: 0 -7px 9px 0 rgba(0, 0, 0, 0.05);
    .infoFrom {
      ::v-deep .van-cell {
        padding-bottom: 0;
        &::after {
          border-bottom: none;
        }
        .van-field__body {
          height: 36px;
          background: #fff;
          border: 1px solid #ddd;
          border-radius: 5px;
          .van-field__control {
            text-indent: 10px;
          }
        }
      }
    }
    .lawfulRight {
      display: block;
      padding: 29px 0;
      color: #999;
      font-weight: 400;
      font-size: 24px;
      line-height: 33px;
    }
    button {
      display: block;
      width: 678px;
      height: 80px;
      margin: 0 auto;
      color: #fff;
      font-weight: 500;
      font-size: 29px;
      line-height: 80px;
      background: #ff6c02;
      border-radius: 45px;
      &.noActive {
        opacity: 0.5;
      }
      &.garynoActive {
        background: #ddd;
      }
    }
    p {
      padding-top: 29px;
      color: #999;
      font-weight: 400;
      font-size: 24px;
      line-height: 33px;
    }
  }
  .footTime {
    position: fixed;
    right: 0;
    bottom: 0;
    left: 0;
    background: #fff;
    box-shadow: 0 -7px 9px 0 rgba(0, 0, 0, 0.05);
    .footTimeContent {
      padding: 32px 36px 30px 36px;
      .agreementTime {
        margin-bottom: 10px;
        color: #333;
        font-weight: 500;
        font-size: 30px;
        line-height: 36px;
        b {
          margin-left: 12px;
        }
      }
    }
  }
  .knowAgreement {
    box-sizing: border-box;
    width: 634px;
    min-height: 511px;
    padding: 29px 48px;
    background: #fff;
    border-radius: 14px;
    > div {
      h2 {
        padding-bottom: 35px;
        color: #000;
        font-weight: 500;
        font-size: 33px;
        line-height: 45px;
        text-align: center;
      }
      h3 {
        color: #000;
        font-weight: 400;
        font-size: 25px;
        line-height: 40px;
      }
      > div {
        width: 326px;
        height: 80px;
        margin: 43px auto 10px auto;
        color: #fff;
        font-weight: 500;
        font-size: 29px;
        line-height: 80px;
        text-align: center;
        background: #ff6c02;
        border-radius: 40px;
      }
    }
  }
}
.toolbar {
  display: none !important;
}
.verificationBox {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  box-sizing: border-box;
  width: 100%;
  margin: 0 auto;
  padding-right: 32px;
  .verify_phone_btn {
    width: 210px;
    height: 72px;
    color: #fff;
    font-weight: 400;
    font-size: 25px;
    line-height: 72px;
    background: #ddd;
    border-radius: 7px;
    ::v-deep .van-cell {
      padding-right: 0 !important;
    }
    .minutes {
      font-size: 16px;
    }
  }
}
.pravieWarrp {
  box-sizing: border-box;
  width: 100%;
  padding: 0 33px;
  > span {
    display: block;
    padding: 29px 0;
    color: #999;
    font-weight: 400;
    font-size: 24px;
    line-height: 33px;
    text-align: left;
  }
  .pravieBox {
    display: flex;
    align-items: center;
    padding-bottom: 29px;
    color: #333;
    font-weight: 400;
    font-size: 25px;
    line-height: 36px;
    img {
      width: 28px;
      height: 28px;
      margin-right: 10px;
    }
    span {
      color: #ff6c02;
    }
  }
}
.orangebtn {
  background: #ff6c02 !important;
  cursor: pointer;
}
.agreementWait {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 11111;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  .waitCenter {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 56%;
    height: 145px;
    background: #fff;
    border-radius: 15px;
    transform: translate(-50%, -50%);
    div {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 145px;
      img {
        width: 72px;
        height: 72px;
        margin-right: 22px;
      }
      span {
        color: #333;
        font-weight: 400;
        font-size: 26px;
        line-height: 40px;
      }
    }
  }
}
.sliderCode {
  height: 70px;
  margin: 20px 0 0 0;
}
::v-deep .nc_wrapper {
  margin: 0 auto;
}
::v-deep .nc-container .nc_scale .btn_ok,
::v-deep .nc-container .nc_scale span {
  height: 68px !important;
}
._nc .stage1 .slider {
  height: 52px !important;
  background-color: #ddd !important;
  border-radius: 0 !important;
  box-shadow: 0 0 3px #999 !important;
}
._nc .stage1 .track div {
  color: #fff !important;
  border-radius: 0 !important;
}
.nc .stage1 .bg-green {
  background-color: #78c430 !important;
}
.nc .stage1 .bg-red {
  background-color: #78c430 !important;
}
</style>
